import { useIntl } from "react-intl";
import { Button, Dialog } from "@rio-cloud/rio-uikit";
import { useState } from "react";
import { Asset } from "../../../../models/asset";
import { updateUptimeAsset } from "../../../../api/fetchAssets";

interface IEditOrdometerHourmeterDialogProps {
    type: string;
    asset: Asset;
    onClose: (chassis: string) => void;
}

export const EditOrdometerHourmeterDialog = (props: IEditOrdometerHourmeterDialogProps) => {
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState<number | undefined>();
    const [loading, setLoading] = useState(false);

    const handleOpen = () => {
        setValue(undefined);
        setLoading(false);
        setOpen(true);
    };

    return (
        <>
            <span
                className="rioglyph rioglyph-pencil-square text-size-18 cursor-pointer"
                onClick={handleOpen}
            />

            <Dialog
                show={open}
                title={intl.formatMessage({
                    id: props.type === 'odometer' ? "intl-msg:monitoring.edit.updateOdometer" : "intl-msg:monitoring.edit.updateHourmeter"
                })}
                subtitle={intl.formatMessage({ id: "intl-msg:monitoring.edit.subtitle" })}
                bsSize="xs"
                footer={
                    <>
                        <button
                            onClick={async () => {
                                if(!value) return;
                                
                                setLoading(true);
                                try {
                                    const now = new Date();

                                    const response = await updateUptimeAsset({
                                        assetId: props.asset.id,
                                        [props.type]: value,
                                        [props.type === 'odometer' ? 'lastOdometerUpdate' : 'lastHourmeterUpdate']: now
                                    });

                                    if(!response) throw new Error();
                                    setLoading(false);
                                    setOpen(false);
                                    setValue(undefined);
                                    props.onClose(props.asset.id);
                                } catch (error) {
                                    console.error(error);
                                    setLoading(false);
                                }

                            }}
                            className={`btn btn-primary ${loading ? 'btn-loading' : ''} margin-right-10`}
                            disabled={!value || loading}
                        >
                            {intl.formatMessage({ id: "intl-msg:monitoring.edit.updateButton" })}
                        </button>
                        <button
                            onClick={() => {
                                setOpen(false);
                                setValue(undefined);
                                setLoading(false);
                            }}
                            className="btn btn-default"
                        >
                            {intl.formatMessage({ id: "intl-msg:monitoring.edit.closeButton" })}
                        </button>
                    </>
                }
                body={
                    <div className="w-full mx-auto bg-white rounded-lg p-6">
                        <div className="form-group">
                            <label htmlFor="value">
                                {props.type === 'odometer'
                                    ? intl.formatMessage({ id: "intl-msg:monitoring.edit.odometerLabel" })
                                    : intl.formatMessage({ id: "intl-msg:monitoring.edit.hourmeterLabel" })
                                }
                            </label>
                            <input
                                id="value"
                                className="form-control"
                                type="text"
                                placeholder={intl.formatMessage({ id: "intl-msg:monitoring.edit.valuePlaceholder" })}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, '');
                                    e.target.value = value;
                                    setValue(parseInt(value || '0'));
                                }}
                            />
                        </div>
                    </div>
                }
            />
        </>
    )
}